/* globals selectboxHandler */

import Swiper from 'swiper'
import { Navigation, Pagination } from 'swiper/modules'

class Documents {
  documents = []
  countDocuments = 0
  cardInnerWidth = 0
  constructor () {
    this.init()
  }

  init () {
    $('.block-documents').each((index, block) => {
      this.initEachBlock($(block))
    })

    $('.wp-block-documents-selectionnes').each((index, block) => {
      this.handlePodcastHeights($(block))
    })
  }

  initEachBlock ($block) {
    const selectType = $block.find('.selectbox-type')
    const selectThematique = $block.find('.selectbox-thematique')
    const blockId = 'block-documents-' + this.countDocuments

    this.documents[this.countDocuments] = $block
    $block.attr('data-number', this.countDocuments)
    $block.attr('id', blockId)
    this.handleEachSelection($block)
    selectType.on('onOptionSelected', event => {
      this.handleEachSelection($block, $(event.currentTarget))
    })

    selectThematique.on('onOptionSelected', event => {
      this.handleEachSelection($block, $(event.currentTarget))
    })

    selectType.on('cleared', event => {
      this.handleEachSelection($block, $(event.currentTarget))
    })

    selectThematique.on('cleared', event => {
      this.handleEachSelection($block, $(event.currentTarget))
    })

    const swiper = new Swiper('#' + blockId + ' .swiper-document', {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      pagination: {
        el: '.swiper-pagination'
      },
      breakpoints: {
        320: {
          slidesPerView: 1.1,
          spaceBetween: 15
        },
        768: {
          slidesPerView: 2.5,
          spaceBetween: 15,
          centerInsufficientSlides: true
        },
        1280: {
          slidesPerView: 3.5,
          spaceBetween: 30,
          centerInsufficientSlides: true
        }
      },
      on: {
        init: function () {
          updateMLClass.call(this)
        },
        slideChange: function () {
          updateMLClass.call(this)
        },
        resize: function () {
          updateMLClass.call(this)
        }
      }
    })

    this.countDocuments++

    this.handlePodcastHeights($block)

    function updateMLClass () {
      if (window.innerWidth >= 1024) {
        if (this.isEnd) {
          $('.swiper-document .swiper-wrapper').addClass('ml-[-30px]')
        } else {
          $('.swiper-document .swiper-wrapper').removeClass('ml-[-30px]')
        }

        if (this.isBeginning) {
          $('.swiper-document .swiper-wrapper').addClass('ml-[30px]')
        } else {
          $('.swiper-document .swiper-wrapper').removeClass('ml-[30px]')
        }
      }
    }
  }

  handlePodcastHeights ($block) {
    setInterval(() => {
      this.calculPodcastHeight($block)
    }, 1000)
  }

  calculPodcastHeight ($block) {
    $block.find('.card-document.card-document .card-document-iframe').each((index, iframeInner) => {
      /// console.log($(iframeInner).innerWidth())

      const width = $(iframeInner).innerWidth() + 10
      if (this.cardInnerWidth === width) {
        return
      }
      this.cardInnerWidth = width
      const innerWidth = width
      const W = 500
      const H = 225
      const scale = innerWidth / W
      const height = H * scale
      // const heightScale = height * scale
      $block.find('.card-document-iframe-inner').css(
        {
          transform: 'scale(' + scale + ')',
          height: height + 125
        })
      $block.find('.card-document-iframe').css(
        {
          'padding-top': height + 'px'
        }
      )
    })
  }

  handleEachSelection ($block, $select) {
    const $btnSearch = $block.find('.block-documents-search-btn')
    const href = $btnSearch.data('href') + '?' + this.getParams($block)
    $btnSearch.find('.x-button-link').attr('href', href)
    $block.find('.selectbox-type .selectbox-apply').attr('href', href)
    $block.find('.selectbox-thematique .selectbox-apply').attr('href', href)
  }

  getParams ($block) {
    const types = selectboxHandler.getAllSelectedOptions($block.find('.selectbox-type'))
    const themes = selectboxHandler.getAllSelectedOptions($block.find('.selectbox-thematique'))
    const searchParams = new URLSearchParams()

    if (types.length) {
      searchParams.set('types', types.toString())
    } else {
      searchParams.delete('types')
    }

    if (themes.length) {
      searchParams.set('themes', themes.toString())
    } else {
      searchParams.delete('themes')
    }

    return searchParams.toString()
  }
}

export default Documents
